import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { AciveUsersPermissions, DocumentCategoryUserRolePermissions, IDocument, IDocument_locname, ISubCategorys, PatientTeleDoc } from 'src/app/models/IDocument';
import { Observable } from 'rxjs';
//import { Configuration } from 'src/app/Utilities/configurations';
// var Configuration = require('src/assets/app-config.json');
import { configuration } from 'src/environments/environment';
import { IUserDetails } from 'src/app/models/IUsersDetails';
@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  temppage: number = 0;
  pageField = [];
  exactPageList: any;
  constructor(private http: HttpClient) { }

  // get all document categories
  //getallDocumentPagination
  getallDocumentsDataPagination(patId: number, faciId: number, catId: number, pageNo, pageSize, searchTerm, documentType): Observable<IDocument_locname[]> {
    const posteddata = {
      patientid: patId,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      locationId: sessionStorage.getItem("LocationId"),
      clientId: sessionStorage.getItem("FacilityId"),
      docCatId: catId,
      pageNo: pageNo,
      pageSize: pageSize,
      searchTerm: searchTerm
      , documentType: documentType
    }
    const jsonposteddata = {
      inputdata: JSON.stringify(posteddata)
    }
    return this.http.post<IDocument_locname[]>(`${configuration.apiUrl + 'Document/DocumentsPaginator'}`, jsonposteddata);
  }

  getCountDocuments(patId: number, catId: number, searchText: string, documentType: string): Observable<any> {
    const posteddate = {
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      clientId: sessionStorage.getItem("FacilityId"),
      docCatId: catId,
      patientid: patId,
      searchTerm: searchText,
      documentType: documentType
    }
    const jsonposteddata = {
      inputdata: JSON.stringify(posteddate)
    }

    return this.http.post<any>(`${configuration.apiUrl + 'Document/GetCountDocumentpage'}`, jsonposteddata);
  }

  pageOnLoad() {
    if (this.temppage == 0) {
      this.pageField = [];
      // this.exactPageList = 0;
      for (var a = 0; a < this.exactPageList; a++) {
        this.pageField[a] = this.temppage + 1;
        this.temppage = this.temppage + 1;
      }
    }
  }
  getAllDocCategory(patId: number, clientId: number, ISALLDOCCAT: number = 0): Observable<IDocument[]> {
    const AllDocCategories_PenRequest = {
      loggeduser: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      origin: '',
      locationId: encodeURIComponent(sessionStorage.getItem("LocationId")).toString(),
      patId: patId,
      clientId: clientId,
      ISALLDOCCAT: ISALLDOCCAT
    }
    return this.http.post<IDocument[]>(`${configuration.apiUrl + 'Document/Categories'}`, AllDocCategories_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  /*
    CheckPath(FilePath:string): Observable<boolean> {
      return this.http.get<boolean>(`${configuration.apiUrl + 'Document/CheckPath'}?path=${FilePath}`, {
        headers: new HttpHeaders({ 'content-Type': 'application/json' })
      });
    }
    */
  getValidFilePath(patharray: string[], FilePath: string): Observable<string> {
    return this.http.get<string>(`${configuration.apiUrl + 'Document/getValidFilePath'}?NewFileName=${encodeURIComponent(FilePath)}&&UserId=${encodeURIComponent(sessionStorage.getItem("username")).toString()}`,
      {
        headers: new HttpHeaders({ 'content-Type': 'application/json' }),
        params: { patharray: patharray }
      });
  }

  viewDocument(fileName: string, filePath: string): Observable<string> {
    return this.http.get<string>(`${configuration.apiUrl + 'Document/viewdocument'}?NewFileName=${encodeURIComponent(fileName)}&&UserId=${encodeURIComponent(sessionStorage.getItem("username")).toString()}`,
      {
        headers: new HttpHeaders({ 'content-Type': 'application/json' }),
        params: { patharray: filePath }
      });
  }

  getValiddataFilePath(patharray: string[], FilePath: string): Observable<Blob> {
    return this.http.get<Blob>(`${configuration.apiUrl + 'Document/getValidFilePath'}?NewFileName=${encodeURIComponent(FilePath)}&&UserId=${encodeURIComponent(sessionStorage.getItem("username")).toString()}`,
      {
        headers: new HttpHeaders({ 'content-Type': 'application/json' }),
        params: { patharray: patharray }
      });
  }

  getDocBlobdata(url) {

    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    headers = headers.set('Access-Control-Allow-Origin', '*')
    headers = headers.set('No-Auth', 'True')
    // return this.http.get(url, { headers: headers, responseType: 'blob' as 'json' });
    return this.http.get(url, { headers: headers, responseType: "blob" })


  }

  getAllLocDocCategory(patId: number, clientId: number): Observable<IDocument[]> {
    const AllLocDocCategories_PenRequest = {
      loggeduser: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      origin: '',
      locationId: encodeURIComponent(sessionStorage.getItem("LocationId")).toString(),
      patId: patId,
      clientId: clientId
    }
    return this.http.post<IDocument[]>(`${configuration.apiUrl + 'Document/AllLocCategories'}`, AllLocDocCategories_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  //insert the patient document
  insertDocument(docInfo: FormData): Observable<IDocument> {
    return this.http.post<IDocument>(`${configuration.apiUrl + 'Document/Document'}`, docInfo);
  }


  UpdateDocumentNotes(Jsonobj: FormData): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Document/UpdateDocumentNotes'}`, Jsonobj
    );
  }


  GetDocNotesLog(DocumentID: number): Observable<IDocument_locname[]> {
    return this.http.get<IDocument_locname[]>(
      `${configuration.apiUrl + 'Document/GetDocNotesLog'}?DocID=${DocumentID.toString()}`);
  }

  getAllProviders(role: string): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(
      `${configuration.apiUrl + 'Admin/ByRole'}?roleid=${role}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&active=true&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  // get all patient documents


  getAllDocuments(patientid: number, facilityId: number, catId: number, clientId: number): Observable<IDocument[]> {
    const _allDocuments_PenRequest = {
      patientid: patientid,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      locationId: sessionStorage.getItem("LocationId"),
      clientId: clientId,
      docCatId: catId
    }
    return this.http.post<IDocument[]>(
      `${configuration.apiUrl + 'Document/AllDocuments'}`, _allDocuments_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }



  getAllDocumentslocName(patientid: number, facilityId: number, catId: number, clientId: number): Observable<IDocument_locname[]> {
    const _allDocuments_PenRequest = {
      patientid: patientid,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      locationId: sessionStorage.getItem("LocationId"),
      clientId: clientId,
      docCatId: catId
    }
    return this.http.post<IDocument_locname[]>(
      `${configuration.apiUrl + 'Document/AllDocuments'}`, _allDocuments_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  // getDocumentUrl(facilityId: number, patientid: number, docCatId: number, docmentId: number, extension: string): Observable<string> {
  //   return this.http.get<string>(
  //     // tslint:disable-next-line: max-line-length
  //     `${Configuration.apiUrl + 'Document/DocumentUrl'}?facilityId=${facilityId}&patientid=${patientid}&doccatId=${docCatId}&docId=${docmentId}&extension=${extension}&userid=admin`
  //   );
  // }
  //update patient document
  updateDocument(docInfo: IDocument): Observable<IDocument> {
    return this.http.put<IDocument>(`${configuration.apiUrl + 'Document/ImportDoc'}?locationId=${sessionStorage.getItem("LocationId")}`, docInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // delete patient document
  deleteDocument(docInfo: IDocument[]): Observable<IDocument> {
    const posteddata = {
      inputdata: JSON.stringify(docInfo)
    }
    return this.http.post<IDocument>(`${configuration.apiUrl + 'Document/DeleteImportDoc'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  // get subcategories of the documents
  getAllSubCategory(): Observable<IDocument[]> {
    return this.http.get<IDocument[]>(`${configuration.apiUrl + 'Document/AllSubCategory'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getAllSubCategoryByCategoryID(catId: number): Observable<ISubCategorys[]> {
    return this.http.get<ISubCategorys[]>(`${configuration.apiUrl + 'Document/SubCategoryByCatId'}?catId=${catId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }


  // check and gets existing document count if exists


  getDocumentsCount(patId: number, catId: number, subCatId: number, docDate: string, docname: string, docloc: number): Observable<number> {
    const DocumentCount_PenRequest = {
      patId: patId,
      catId: catId,
      subCatId: subCatId,
      docDate: docDate,
      docname: docname,
      userId: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      locationId: docloc
    }
    return this.http.post<number>(
      `${configuration.apiUrl + 'Document/DocumentCount'}`, DocumentCount_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  getPDMPDocumentsCount(patId: number, catId: number, subCatId: number, docDate: string, docName: string): Observable<number> {
    const _document_PenRequest = {
      patId: patId,
      catId: catId,
      subCatId: subCatId,
      userId: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      locationId: encodeURIComponent(sessionStorage.getItem("LocationId")).toString(),
      docName: docName,
      docDate: docDate
    }
    return this.http.post<number>(
      `${configuration.apiUrl + 'Document/PDMPDocumentCount'}`, _document_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  //insert document master sub category
  SaveSubCategory(docInfo: IDocument): Observable<IDocument> {
    return this.http.post<IDocument>(`${configuration.apiUrl + 'Document/SubCategory'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, docInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  //insert document master category
  SaveDocCategory(docInfo: IDocument, facId: number): Observable<IDocument> {
    return this.http.post<IDocument>(`${configuration.apiUrl + 'Document/DocCategory'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&locationId=${encodeURIComponent(sessionStorage.getItem("LocationId")).toString()}&&clientId=${Number(facId)}`, docInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  insertLicenseAndInsurenceCategory(catName: string, subCatName: string): Observable<IDocument> {
    const postedData = {
      catName: catName,
      subCatName: subCatName,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facId: sessionStorage.getItem("FacilityId")

    }
    return this.http.post<IDocument>(`${configuration.apiUrl + 'Patient/ImportCheckInDoc'}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
    // return this.http.post<IDocument>(`${configuration.apiUrl + 'Patient/ImportCheckInDoc'}?catName=${catName}&&subCatName=${subCatName}&&facId=${Number(sessionStorage.getItem("FacilityId"))}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
    //   headers: new HttpHeaders({ 'content-Type': 'application/json' })
    // });
  }

  getCheckedInDocuments(patientid: number, catName: string, subCatName: string): Observable<IDocument> {
    const CheckedInDoc_PenRequest = {
      patId: patientid,
      locId: encodeURIComponent(sessionStorage.getItem("LocationId")).toString(),
      docCatName: catName,
      subCatName: subCatName,
      userId: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    return this.http.post<IDocument>(
      `${configuration.apiUrl + 'Document/CheckedInDoc'}`, CheckedInDoc_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // get all Import document categories
  // getAllImportDocCategory(patId:number, clientId: number): Observable<IDocument[]> {
  //   return this.http.get<IDocument[]>(`${configuration.apiUrl + 'Document/ImportAllCategories'}?loggeduser=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&locationId=${encodeURIComponent(sessionStorage.getItem("LocationId")).toString()}&&patId=${patId}&&origin&&clientId=${clientId}`);
  // }

  getAllImportDocCategory(patId: number, clientId: number): Observable<IDocument[]> {
    const ImportAllCategories_PenRequest = {
      loggeduser: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      origin: origin,
      locationId: encodeURIComponent(sessionStorage.getItem("LocationId")).toString(),
      patId: patId
    }
    return this.http.post<IDocument[]>(`${configuration.apiUrl + 'Document/ImportAllCategories'}`, ImportAllCategories_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  DeleteAddCategory(Id: number): Observable<number> {
    return this.http.delete<number>(`${configuration.apiUrl + 'Document/DeleteAddCategory'}?categoryId=${Id}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getAllCategoriesCount(categoryId: number): Observable<number> {
    return this.http.get<number>(
      `${configuration.apiUrl + 'Document/GetAllCategoriesCountByCatId'}?categoryId=${categoryId}`);
  }

  insertFluoroscopeDocment(docInfo: FormData): Observable<IDocument> {
    return this.http.post<IDocument>(`${configuration.apiUrl + 'Document/FluoroscopeDocument'}`, docInfo);
  }
  insertPDMPScoreDocment(docInfo: FormData): Observable<IDocument> {
    return this.http.post<IDocument>(`${configuration.apiUrl + 'Document/PDMPScoreDocument'}`, docInfo);
  }
  insertPreviewCategory(catName: string, subCatName: string): Observable<IDocument> {
    const postedData = {
      catName: catName,
      subCatName: subCatName,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facId: sessionStorage.getItem("FacilityId")

    }
    return this.http.post<IDocument>(`${configuration.apiUrl + 'Patient/FluororDoc'}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
    // return this.http.post<IDocument>(`${configuration.apiUrl + 'Patient/FluororDoc'}?catName=${catName}&&subCatName=${subCatName}&&facId=${Number(sessionStorage.getItem("FacilityId"))}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
    //   headers: new HttpHeaders({ 'content-Type': 'application/json' })
    // });
  }

  insertImageCategory(catName: string, subCatName: string, patId: string, locId: string): Observable<IDocument> {
    const postedData = {
      catName: catName,
      subCatName: subCatName,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facId: sessionStorage.getItem("FacilityId"),
      patId: patId,
      locId: locId
    }
    return this.http.post<IDocument>(`${configuration.apiUrl + 'Patient/ImportCheckInDoc'}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
    // return this.http.post<IDocument>(`${configuration.apiUrl + 'Patient/ImportCheckInDoc'}?catName=${catName}&&subCatName=${subCatName}&&facId=${Number(sessionStorage.getItem("FacilityId"))}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
    //   headers: new HttpHeaders({ 'content-Type': 'application/json' })
    // });
  }


  getDocumentsCountAndDocId(patId: number, catId: number, subCatId: number, docDate: string): Observable<IDocument> {
    const DocumentId_PenRequest = {
      patId: patId,
      catId: catId,
      subCatId: subCatId,
      userId: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      locationId: encodeURIComponent(sessionStorage.getItem("LocationId")).toString()
    }
    return this.http.post<IDocument>(
      `${configuration.apiUrl + 'Document/DocumentCountAndDocId'}`, DocumentId_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  insertDocumentOrderTracker(docInfo: FormData): Observable<IDocument> {
    return this.http.post<IDocument>(`${configuration.apiUrl + 'Document/DocumentOrderstracker'}`, docInfo);
  }

  //***** Import Referral Tracker Document */

  importPatientReferralTrackerDocument(docInfo: FormData): Observable<IDocument> {
    return this.http.post<IDocument>(`${configuration.apiUrl + 'Document/ImportReferralTrackerDocument'}`, docInfo);
  }


  updateProviderReferenceStatus(referralId: number, referenceSheetStatus: boolean, documentId: string): Observable<number> {
    const ProviderRefStatus_PenRequest = {
      referralId: referralId,
      referenceSheetStatus: referenceSheetStatus,
      documentId: documentId
    }
    return this.http.post<number>(`${configuration.apiUrl + 'Document/UpdateProviderRefStatus'}`, ProviderRefStatus_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  getAllDocumentsByPatientReferrals(DocId: number, PatId: number): Observable<IDocument_locname[]> {
    const DocByRefTracker_PenRequest = {
      loggeduser: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      locationId: encodeURIComponent(sessionStorage.getItem("LocationId")).toString(),
      DocId: DocId,
      PatId: PatId,
      clientId: Number(sessionStorage.getItem("FacilityId"))
    }
    return this.http.post<IDocument_locname[]>(`${configuration.apiUrl + 'Document/CategoriesReferralTracker'}`, DocByRefTracker_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }



  InsertUpdateProviderReferenceStatus(referralId: number, referenceSheetStatus: boolean, documentId: string, patientId: number, referralTrkMastId: number): Observable<string> {
    const ProvidersRefStatus_PenRequest = {
      referralId: referralId,
      referenceSheetStatus: referenceSheetStatus,
      documentId: documentId,
      patientId: patientId,
      referralTrkMastId: referralTrkMastId,
      userId: encodeURIComponent(sessionStorage.getItem("userId")).toString(),

    }
    return this.http.post<string>(`${configuration.apiUrl + 'Document/InsertUpdateProviderRefStatus'}`, ProvidersRefStatus_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  DeleteDocumentCategory(Id: number): Observable<number> {
    return this.http.delete<number>(`${configuration.apiUrl + 'Document/DeleteDocumentCategory'}?categoryId=${Id}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  GetUserPermissionsOfDocumentCategory(locationId: number, RoleId: string, RequestType: string, UserId: string): Observable<DocumentCategoryUserRolePermissions[]> {

    if (!UserId) {
      UserId = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    }
    const posteddata = {
      LoginUser: UserId,
      LocationId: locationId,
      RoleID: RoleId,
      Requesttype: RequestType
    }
    return this.http.post<DocumentCategoryUserRolePermissions[]>(
      `${configuration.apiUrl + 'Document/GetUserPermissionsOfDocumentCategory'}`, posteddata);
  }

  ModifyUserPermissionsOfDocumentCategory(inputData: DocumentCategoryUserRolePermissions[], type: string): Observable<DocumentCategoryUserRolePermissions> {
    const postedData = {
      inputData: JSON.stringify(inputData)
    }
    return this.http.post<DocumentCategoryUserRolePermissions>(`${configuration.apiUrl + 'Document/ModifyUserPermissionsOfDocumentCategory'}?type=${type}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  GetPatientChatDoc(): Observable<PatientTeleDoc[]> {
    const postedDataObj = {
      encId: sessionStorage.getItem("encounterid"),
      locId: Number(sessionStorage.getItem("LocationId")),
      patId: sessionStorage.getItem("patientId")
    }
    return this.http.post<PatientTeleDoc[]>(`${configuration.apiUrl + 'Scheduler/PatChatDocs'}`, postedDataObj, {
      headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' })
    });

  }
  UploadDirectMsgDocument(docObject: IDocument, fluoroDocUrl: string): Observable<string> {
    const postedData = {
      inputData: JSON.stringify(docObject),
      signature: encodeURIComponent(fluoroDocUrl)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Document/UploadDirectDoc'}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  GetComponentRolePermissions(roleid: string, requestType: string, userid: string): Observable<any> {
    // const userid = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    return this.http.get<any>(
      `${configuration.clinicapiUrl + 'Master/GetComponentRolePermissions'}?userid=${userid}&&roleid=${roleid}&&requestType=${requestType}`);
  }
  ModifyUserPermissionsOfComponents(inputData: any, type: string): Observable<any> {
    const postedData = {
      inputData: JSON.stringify(inputData)
    }
    return this.http.post<any>(`${configuration.clinicapiUrl + 'Master/ModifyUserPermissionsOfComponents'}?type=${type}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  DrugInteractionCheckPermissions(inputData: any, type: string): Observable<any> {
    const postedData = {
      inputData: JSON.stringify(inputData)
    }
    return this.http.post<any>(`${configuration.clinicapiUrl + 'Master/DrugInteractionCheckPermissions'}?type=${type}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  EmergencyUserPermissions(inputData: any, type: string): Observable<any> {
    const postedData = {
      inputData: JSON.stringify(inputData)
    }
    return this.http.post<any>(`${configuration.clinicapiUrl + 'Master/EmergencyUserPermissions'}?type=${type}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  GetPatientBoardMenuPermissions(): Observable<any> {
    let type = 'patboard'
    const userid = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    return this.http.get<any>(
      `${configuration.apiUrl + 'Activation/GetPatientBoardMenuPermissions'}?type=${type}&&userid=${userid}`);
  }
  GetUserMenuPermissions(roleid: string, requestType: string, userid: string): Observable<any> {
    // const userid = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    return this.http.get<any>(
      `${configuration.apiUrl + 'Activation/GetUserMenuPermissions'}?userid=${userid}&&roleid=${roleid}&&requestType=${requestType}`);
  }
  ModifyUserPermissionsOfMenus(inputData: any, type: string): Observable<any> {
    const postedData = {
      inputData: JSON.stringify(inputData)
    }
    return this.http.post<any>(`${configuration.apiUrl + 'Activation/ModifyUserPermissionsOfMenus'}?type=${type}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  UploadCDAMsgDocument(docObject: IDocument, fluoroDocUrl: string): Observable<string> {
    const postedData = {
      inputData: JSON.stringify(docObject),
      signature: encodeURIComponent(fluoroDocUrl)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Document/UploadCDADoc'}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  //get all Document Types
  getallDocumentsTypes(patId: number): Observable<IDocument_locname[]> {
    const posteddata = {
      patientid: patId,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      locationId: sessionStorage.getItem("LocationId"),
      clientId: sessionStorage.getItem("FacilityId"),
    }
    return this.http.post<IDocument_locname[]>(`${configuration.apiUrl + 'Document/AllDocumentsTypes'}`, posteddata);
  }

  ModifyAcitveUser(inputData: any, type: string): Observable<any> {
    const postedData = {
      inputData: JSON.stringify(inputData)
    }
    return this.http.post<any>(`${configuration.apiUrl + 'Activation/ModifyActiveUsers'}?type=${type}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  GetActiveUsersPermissions(locationId: number, RoleId: string, RequestType: string, UserId: string): Observable<AciveUsersPermissions[]> {
    if (!UserId) {
      UserId = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    }
    const posteddata = {
      LoginUser: UserId,
      LocationId: locationId,
      RoleId: RoleId,
      Requesttype: RequestType
    }
    return this.http.post<AciveUsersPermissions[]>(
      `${configuration.apiUrl + 'Activation/GetActiveUsersinRolesAndPermissions'}`, posteddata);
  }
}